<template>
  <div id="gift-box-modal" v-if="purchaseItem">
    <div class="modal-container">
      <div class="close-btn-photo">
        <span @click="$emit('close')"><i class="fa-solid fa-xmark fa-lg"></i></span>
      </div>

      <GiftBoxItem :gift-box="localItem" :update-mode="updateMode" @add-to-cart="submit($event)" @update-cart-item="submit($event)" @remove-from-cart="removeFromCart($event)"/>
    </div>
  </div>
</template>

<script>
import GiftBoxItem from '../../pages/gift_boxes/GiftBoxItem.vue';

export default {
  name: 'GiftBoxModal',
  components: { GiftBoxItem },
  props: {
    purchaseItem: Object,
    updateMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localItem: JSON.parse(JSON.stringify(this.purchaseItem))
    };
  },
  methods: {
    submit(item) {
      if (this.updateMode) {
        this.$emit('update', item);
      } else {
        this.$emit('add', item);
      }
    },
    removeFromCart(purchaseId) {
      this.$emit('remove', purchaseId);
    }
  }
};
</script>

<style scoped>
.modal-container {
  margin: 40px auto;
}
</style>
